<script>
	import { onMount } from "svelte";

	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerSubmit } from "../../gtm";

	import PageSection from "../../components/PageSection.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	export let pageIndex = null;
	export let pageTitle = null;

	document.title = pageTitle;

	window.onbeforeunload = null;

	onMount(() => {
		registerSubmit($model.Contact.EmailAddress, $model.Contact.PhoneNumber, $model.RegistrationNumber);
	});
</script>

<PageSection>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName}</h1>
			<h2 class="text-center">
				Thank you for completing your registration form for the {@html projectSettings.classActionName}.
			</h2>
		</FormColumn>
	</FormRow>

	<FormRow>
		<FormColumn>
			<h3>Your reference number</h3>
			<div class="box">{$model.RegistrationNumber}</div>
			<p>
				If you have any questions, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber>, or at <ClassActionEmailAddress
				></ClassActionEmailAddress> and quote the registration number above.
			</p>
		</FormColumn>
	</FormRow>
</PageSection>

<style>
	.box {
		background-color: var(--color-white);
		border: solid 1px var(--color-border);
		border-radius: 1px;
		padding: var(--spacing-sm);
		transition: var(--transition-fast);
		height: 50px;
		font-size: 18px;
		line-height: 26px;
		color: var(--color-body);
	}

	.whats-next {
		background-color: var(--color-white);
		margin: 30px -30px;
		padding: 20px 30px;
	}

	.whats-next h2 {
		margin-bottom: 26px;
	}

	li {
		display: list-item;
		list-style-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"%3E%3Cpath fill="none" stroke="red" stroke-width="2" d="M3 7.5L6 10.5L11 4.5"%3E%3C/path%3E%3C/svg%3E');
	}
</style>
